export default {
	// Config
	apiKey: "AIzaSyBsKXssZwTJcfGsrWSorEUEEZAkl01F_38",
  authDomain: "eureka-mytrace.firebaseapp.com",
  projectId: "eureka-mytrace",
  storageBucket: "eureka-mytrace.firebasestorage.app",
  messagingSenderId: "247708112940",
  appId: "1:247708112940:web:c01803e0a13ecb97edd989"
};
